import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetDashboardApi = (userId) => api.get(`usermaster/user-dashboard`);
export const GetEarningApi = (loginId, params) => api.get(`usermaster/my-earning-zone/${loginId}?${qs(params)}`);
export const GetTradeZoneApi = (loginId, params) => api.get(`usermaster/my-trade-zone/${loginId}?${qs(params)}`);
export const SendIBRequestApi = (data) => api.post('usermaster/ibrequest');
export const GetIBRequestStatusApi = (userId) => api.get(`usermaster/get-ibrequest-status`);
export const YourWallet = (userId) => api.get(`wallet/getwalletdetails/${userId}`);
export const GetAccountSummaryApi = (terminalId) => api.get(`trading/get-account-summary/${terminalId}`);
export const GetOpenTradesApi = (terminalId) => api.get(`trading/get-open-trades/${terminalId}`);
